import { getMonitoring } from '../../api';
import { useListFetch } from '../../hooks';
import { splitCamelCase, splitSnakeCase } from '../../utilities';
import type { CampaignMonitoringItemType } from '../../api';
import type { GetCampaignMonitoringFilters } from '../../api';

export type ItemType = CampaignMonitoringItemType & {
  latest_contact_state_enum: CampaignMonitoringItemType['latest_contact_state'];
};

export const useMonitoring = () => {
  return useListFetch<ItemType, GetCampaignMonitoringFilters>(
    async ({ filters, pagination, sortStr }) => {
      const result = await getMonitoring({
        sort: sortStr,
        page: pagination,
        filters: filters || {},
      });

      return {
        total: result.total,
        content: result.items.map(item => ({
          ...item,
          next_task_channel: splitCamelCase(item.next_task_channel),
          latest_contact_state_enum: item.latest_contact_state,
          latest_contact_state: splitSnakeCase(item.latest_contact_state, {
            capitalize: true,
          }),
        })),
      };
    },
    {
      initialPageSize: 50,
      initialFilters: { latestContactStateEnum: undefined },

      withQueryParams: true,
      // storageKey: 'use-monitoring-list',
    }
  );
};
